import * as React from 'react'
import CustomTabs from '../shared/CustomTabs'

interface Props {
	activeTab: string
	onTabSelect: (tabKey: string) => void
}

const ArticleTabs = ({ activeTab, onTabSelect }: Props) => {
	const articleTabs = [
		{
			key: 'article-1',
			label: 'Article - #1',
			icon: (
				<svg width="18" height="14" viewBox="0 0 18 14" fill="currentColor">
					<path d="M3 0H0V14H3V0ZM8 0H5V14H8V0ZM13 0H10V14H13V0ZM18 0H15V14H18V0Z" />
				</svg>
			),
		},
		{
			key: 'add-more',
			label: 'Add more articles',
			icon: (
				<svg width="14" height="14" viewBox="0 0 14 14" fill="currentColor">
					<path d="M8 0H6V6H0V8H6V14H8V8H14V6H8V0Z" />
				</svg>
			),
		},
	]

	return <CustomTabs tabs={articleTabs} activeTab={activeTab} onTabSelect={onTabSelect} className="article-tabs" />
}

export default ArticleTabs
